import React from 'react';
import { View } from 'react-native';
import LinearGradient from 'utils/packages/linearGradient';
import Text from 'design-system/Text';
import Links from 'utils/links';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { rem } from 'design-system';
import useColors from 'hooks/useColors';
const QuotePromotionBanner = ({ promotion }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const onPressLink = () => {
        if (promotion.termsAndConditionsUrl) {
            Links.openLink(promotion.termsAndConditionsUrl);
        }
    };
    return (<View>
      <LinearGradient {...colors.gradients.skyBlue} style={styles.titleContainer}>
        <Text Text-16 White>
          {promotion.isExclusive ? 'Exclusive Offer' : 'Special Offer'}
        </Text>
      </LinearGradient>
      <View style={styles.termsContainer}>
        <Text TextThin-14>
          {promotion.text} -{' '}
          <Text TextThin-14 Blue onPress={onPressLink}>
            Offer Terms &amp; Conditions
          </Text>
        </Text>
      </View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    titleContainer: {
        padding: rem(16),
        backgroundColor: colors.cards.brand,
    },
    termsContainer: {
        paddingVertical: rem(5),
        paddingHorizontal: rem(16),
        backgroundColor: colors.cards.onLight,
    },
}));
export default QuotePromotionBanner;
